import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Lottie from 'react-lottie';
import * as animationData from 'assets/animations/done.json';
import Modal from 'components/Modal';
import './styles.scss';

function SuccessModal({
  literals,
  title = '',
  description = '',
  children = null,
  onClose,
}) {
  return (
    <Modal
      onClose={onClose}
      position='end'
      className='feedback-modal'
    >
      <div className='text-center'>
        <Lottie
          options={{
            loop: false,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            },
          }}
          height={90}
          width={90}
        />
        <h3 className='mt-1'>
          {title || literals.successTitle}
        </h3>
        {description && (
          <h3 className='text-neutral-500 font-normal mt-6'>
            {description}
          </h3>
        )}
        {children}
      </div>
    </Modal>
  );
}

SuccessModal.propTypes = {
  literals: PropTypes.object.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

/* *************************************** */
/* ********       CONTAINER       ******** */
/* *************************************** */

function mapStateToProps(state) {
  return {
    literals: {
      ...state.i18n.literals.feedbackModal,
      ...state.i18n.literals.common,
    },
  };
}

export default connect(mapStateToProps)(SuccessModal);
